var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "scp-progress-backdrop",
          attrs: { role: "status", "aria-live": "polite" },
        },
        [
          _c(
            "div",
            { staticClass: "scp-progress-card" },
            _vm._l(_vm.steps, function (step) {
              return _c(
                "div",
                { key: step.id, staticClass: "scp-progress-step" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "scp-progress-marker",
                      class: `is-${step.status}`,
                    },
                    [
                      step.status === "done"
                        ? _c("span", [_vm._v("✓")])
                        : step.status === "error"
                        ? _c("span", [_vm._v("✕")])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "scp-progress-label",
                      class: { "is-pending": step.status === "pending" },
                    },
                    [_vm._v(" " + _vm._s(step.label) + " ")]
                  ),
                ]
              )
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }